module.exports = __webpack_public_path__ + "media/images/flags/16/Pitcairn-Islands-10740520eb68a67aaf94aa05a9162539.png";